import React from 'react';

const Copyright = () => {
  return <div>
    <a href='https://t.me/mykhail_druz'>© Mykhail Druz - 2023</a>
  </div>;
};

export default Copyright;
